import { render, staticRenderFns } from "./NewerGuide.vue?vue&type=template&id=0089088d"
import script from "./NewerGuide.vue?vue&type=script&lang=js"
export * from "./NewerGuide.vue?vue&type=script&lang=js"
import style0 from "./NewerGuide.vue?vue&type=style&index=0&id=0089088d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports